// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"QueryBuilderView_subtitle__60lqk","title":"QueryBuilderView_title__1HW_t","Container":"QueryBuilderView_Container__J5cBp"};